import styled from "styled-components";

export const ProjectCard = styled.div`
  position: relative;
  height: clamp(250px, 20vw, 400px);
  overflow: hidden;
  background-color: ${props => props.color || '#5C6BC0'};
  cursor: pointer;
  transition: transform 0.3s ease;
  box-shadow: 0 clamp(5px, 0.625vw, 12px) clamp(12px, 1.5625vw, 30px) rgba(0,0,0,0.1);

  /* Radius permanents */
  &.first-card { 
    border-top-left-radius: clamp(20px, 1.35vw, 26px);
  }
  &.second-card { 
    border-top-right-radius: clamp(20px, 1.35vw, 26px);
  }
  &.third-card { 
    border-bottom-left-radius: clamp(20px, 1.35vw, 26px);
  }
  &.fourth-card { 
    border-bottom-right-radius: clamp(20px, 1.35vw, 26px);
  }

  /* Image de fond */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url(${props => props.image});
    background-size: cover;
    background-position: center;
    filter: blur(0.6px) brightness(0.96);
    transition: filter 0.4s ease;
    border-radius: inherit; /* <-- clé pour conserver les coins arrondis */
    z-index: 1;
  }

  /* Effet hover sans casser le radius */
  &:hover::before { 
    filter: blur(1px) brightness(0.85);
  }

  &:hover { 
    transform: translateY(clamp(2px, 0.26vw, 5px));
  }

  @media (max-width: 1024px) {
    height: clamp(200px, 15.6vw, 300px);
    border-radius: clamp(15px, 1.14vw, 22px);
  }
`;


export const RealizationsSection = styled.div`
  margin: 0 auto;
  position: relative;
  z-index: 10;
  font-family: Raleway, sans-serif;
  padding: 10px 5px;
  margin-bottom: 2vw;
  
  @media (max-width: 1200px) {
    width: 94vw;
  }

  @media (max-width: 768px) {
    width: 96vw;
    padding: clamp(40px, 2vw, 100px) 2vw;
  }

  @media (max-width: 480px) {
    width: 98vw;
    padding: clamp(40px, 2vw, 100px) 1vw;
  }

  @media (min-width: 2000px) {
    width: 85vw;
    max-width: 1800px;
  }
`;

export const RealizationsHeader = styled.div`
  max-width: 100%;
  margin: 0 auto clamp(30px, 2vw, 70px) auto;
  padding: 0 5.448vw;
  text-align: center;

  @media (max-width: 768px) {
    padding: 0 4vw;
  }

  @media (max-width: 480px) {
    padding: 0 3vw;
  }
`;

export const RealizationsTitleTag = styled.div`
  color: #7874a0;
  font-size: clamp(1.4rem, 1.5vw, 1.8rem);
  font-weight: 200;
  margin-bottom: clamp(5px, 0.5vw, 10px);
`;

export const RealizationsTitle = styled.h2`
  font-size: clamp(2rem, 2.5vw, 3rem);
  font-weight: 200;
  color: #221c46;
  line-height: 1.2;
  margin: 0;
`;

export const RealizationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto auto;
  gap: clamp(20px, 2vw, 45px);
  max-width: 100%;
  margin: 0 auto;
  padding: 0 5.448vw;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    padding: 0 4vw;
  }

  @media (max-width: 768px) {
    padding: 0 4vw;
  }

  @media (max-width: 480px) {
    padding: 0 3vw;
  }
`;


export const CardOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 65%;
  height: 35%;
  background: rgba(20,20,35,0.4);
  backdrop-filter: blur(clamp(5px, 0.5vw, 10px));
  color: #fff;
  text-align: left;
  padding: clamp(15px, 1.3vw, 25px) clamp(20px, 1.5vw, 30px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 2;

  /* Héritage des border-radius pour correspondre au parent */
  .first-card & {
    border-bottom-left-radius: clamp(20px, 1.35vw, 26px);
  }

  .second-card & {
    border-bottom-right-radius: 0;
  }

  .third-card & {
    border-bottom-left-radius: clamp(20px, 1.35vw, 26px);
  }

  .fourth-card & {
    border-bottom-right-radius: clamp(20px, 1.35vw, 26px);
  }

  @media (max-width: 1024px) {
    width: 100% !important;
    border-radius: 0 0 clamp(10px, 1vw, 22px) clamp(10px, 1vw, 22px) !important;
  }
`;

export const CardTitle = styled.h3`
  color: white;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-color: white;
  text-decoration-thickness: clamp(1px, 0.15vw, 2px);
  font-size: clamp(14px, 1vw, 20px);
  font-weight: 200;
  margin-bottom: clamp(0.8vw, 0.2vw, 4px);
`;

export const CardDescription = styled.p`
  color: rgba(255,255,255,0.9);
  font-size: clamp(10px, 0.7vw, 14px);
  line-height: 1.4;
  margin-bottom: clamp(5px, 0.4vw, 8px);
`;

export const CardLink = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(4px, 0.3vw, 6px);
  color: white;
  font-size: clamp(10px, 0.6vw, 13px);
  font-weight: 200;
  opacity: 0.9;

  &:hover {
    text-decoration: underline;
  }
`;

export const FilterContainer = styled.div`
  max-width: 100%;
  margin: clamp(40px, 3vw, 75px) auto 0 auto;
  padding: 0 5.448vw;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: clamp(10px, 1vw, 20px);

  @media (max-width: 768px) {
    padding: 0 4vw;
  }

  @media (max-width: 480px) {
    padding: 0 3vw;
  }
`;